import { Icon } from "../Icon";
import { useCurrentEditor } from "@tiptap/react";
import styles from "./RichTextEditor.module.scss";

type ToolbarButtonProps = {
  onClick?: () => void;
  disabled?: boolean | undefined;
  iconName: string;
  className?: string;
};

export function ToolbarButton({
  onClick,
  disabled,
  iconName,
  className,
}: ToolbarButtonProps) {
  const { editor } = useCurrentEditor();
  if (!editor) {
    return null;
  }
  return (
    <>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={className && editor.isActive(className) ? styles.active : ""}
      >
        <Icon name={iconName} />
      </button>
    </>
  );
}
